import { forwardRef, useCallback, useState } from 'react';

import { Dialog } from 'components';
import { useTemplates } from 'contexts';
import { Booking, Template } from 'types';

type SaveTemplateDialogProps = { booking: Partial<Booking>; closeDialog: () => void };

const SaveTemplateDialog = forwardRef<HTMLDialogElement, SaveTemplateDialogProps>(({ booking, closeDialog }, ref) => {
  const { addTemplate } = useTemplates();

  const [name, setName] = useState('');

  const handleSubmit = useCallback(() => {
    addTemplate({ ...booking, name } as Template);
    closeDialog();
  }, [addTemplate, booking, closeDialog, name]);

  return (
    <Dialog closeDialog={closeDialog} ref={ref}>
      <div className="grid-1 auto-rows">
        <h3 className="text-primary-dark">Save As Template</h3>
        <input
          className="align-self-center w-100"
          placeholder="TEMPLATE NAME"
          value={name}
          onChange={e => setName(e.target.value.toUpperCase())}
        />
        <div className="grid-3 align-self-end">
          <button className="btn-outline col-start-2" onClick={closeDialog}>
            Cancel
          </button>
          <button className="btn-primary col-start-3" disabled={!name.length} onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </Dialog>
  );
});

export default SaveTemplateDialog;
